export default "__VITE_ASSET__qu_adMrv__"